import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import { ISplitterPaneViewModelParameters } from '#/DefaultViewExtensionInterfaces';

export default class SplitterPaneViewModel extends ControlViewModel {
    public isHorizontal: KnockoutObservable<boolean>;

    /**
     * Gibt an, ob die Pane sichtbar ist
     */
    public isExpanded: KnockoutObservable<boolean>;

    /**
     * Gibt an, ob die Pane versteckt werden kann
     */
    public isCollapsible: KnockoutObservable<boolean>;

    /**
     * Gibt an, ob die Pane vergrößert/verkleinert werden kann
     */
    public isResizable: KnockoutObservable<boolean>;

    /**
     * Gibt an, ob die Pane scrollbar ist
     */
    public isScrollable: KnockoutObservable<boolean>;

    /**
     * Gibt die Größe der Pane an wenn diese versteckt ist
     */
    public collapsedSize: KnockoutObservable<number>;

    /**
     * Gibt die Größe der Pane an
     */
    public size: KnockoutObservable<string | number>;

    public calculatedSize: KnockoutObservable<number>;

    /**
     * Gibt die minimale Größe der Pane an
     */
    public min: KnockoutObservable<string | number>;

    /**
     * Gibt die maximale Größe der Pane an
     */
    public max: KnockoutObservable<string | number>;

    /**
     * Gibt an, ob beim Resizen eines Dividers im Splitter ein Overlay über der Pane gerendert werden soll.
     * Dies ist nützlich, wenn im Pane Elemente vorhanden sind, die benötigte Mouse-Events verhindern (bspw. <object>).
     */
    public useResizeOverlay: boolean;
    public showResizeOverlay: KnockoutObservable<boolean>;

    /**
     * Das ViewModel für die SplitterPane
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: ISplitterPaneViewModelParameters) {
        super(params);

        this.isHorizontal = this.observableOrDefault(false);
        this.isExpanded = this.observableOrDefault(params.isExpanded, true);
        this.isCollapsible = this.observableOrDefault(params.isCollapsible, true);
        this.isResizable = this.observableOrDefault(params.isResizable, true);
        this.isScrollable = this.observableOrDefault(params.isScrollable, true);
        this.collapsedSize = this.observableOrDefault(params.collapsedSize, 0);
        this.size = this.observableOrDefault(params.size, null);
        this.calculatedSize = this.observableOrDefault(0);
        this.min = this.observableOrDefault(params.min, null);
        this.max = this.observableOrDefault(params.max, null);
        this.useResizeOverlay = this.paramOrDefault(params.useResizeOverlay, false);
        this.showResizeOverlay = this.observableOrDefault(false);
    }
}

ComponentManager.setViewModel('SplitterPaneViewModel', SplitterPaneViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');